<template>
  <div class="full-area">
    <header class="question-header">
      <h2>{{data.fields.title}}</h2>
    </header>

    <content class="content delay-entry short-delay">
      <div class="grid-wrapper">
        <div class="field-wrapper" v-for="item in data.fields.fields" :key="item">
          <el-input placeholder="Nombre" v-model="form.data.name" v-if="item === 'Nombre'" :key="item" required></el-input>
          <el-input placeholder="Apellido" v-model="form.data.lastname" v-if="item === 'Apellido'" :key="item" required></el-input>
          <el-input placeholder="Email" v-model="form.data.email" v-if="item === 'Email'" :key="item" required type="email"></el-input>
          <el-input placeholder="Ciudad" v-model="form.data.city" v-if="item === 'Ciudad'" :key="item" required></el-input>

          <el-radio v-model="form.data.sex" label="male" v-if="item === 'Sexo'" :key="item + '_male'" required>Masculino</el-radio>
          <el-radio v-model="form.data.sex" label="female" v-if="item === 'Sexo'" :key="item + '_female'" required>Femenino</el-radio>

          <el-select v-model="form.data.ethnicity" placeholder="Etnia" v-if="item === 'Etnia'" :key="item">
            <el-option
              v-for="option in ethnicGroups"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
          <el-select v-model="form.data.age" placeholder="Edad" v-if="item === 'Edad'" :key="item">
            <el-option
              v-for="option in years"
              :key="option"
              :label="option"
              :value="option">
            </el-option>
          </el-select>
        </div>
      </div>
    </content>

    <footer>
      <div class="button-wrapper">
        <el-button
          :disabled="disableSubmit"
          rounded
          type="danger"
          @click="next()"
        >Enviar</el-button>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Demographic',

  props: [ 'data' ],

  data () {
    return {
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        data: {
          name: null,
          lastname: null,
          email: null,
          age: null,
          sex: null,
          city: null,
          ethnicity: null
        },
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      ethnicGroups: [
        { label: 'Ninguna', value: 'ninguna' },
        { label: 'Afrodescendiente', value: 'afrodescendiente' },
        { label: 'Indígena', value: 'indígena' }
      ]
    }
  },

  computed: {
    disableSubmit () {
      if (!this.form.data.name && this.data.fields.fields.includes('Nombre')) { return true }
      if (!this.form.data.lastname && this.data.fields.fields.includes('Apellido')) { return true }
      if (!this.form.data.email && this.data.fields.fields.includes('Email')) { return true }
      if (!this.form.data.age && this.data.fields.fields.includes('Edad')) { return true }
      if (!this.form.data.sex && this.data.fields.fields.includes('Sexo')) { return true }
      if (!this.form.data.city && this.data.fields.fields.includes('Ciudad')) { return true }
      if (!this.form.data.ethnicity && this.data.fields.fields.includes('Etnia')) { return true }
      return false
    },
    years () {
      return Array.from({ length: 90 }, (value, index) => index + 10)
    }
  },

  methods: {
    next () {
      this.form.timestamps.finish = new Date()
      this.form.timestamps.valid = new Date()
      this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      this.$emit('next', this.form)
      console.log(this.form)
    }
  }
}
</script>

<style scoped lang="scss">
  .grid-wrapper {
    align-items: center;
    min-height: 30vh;
  }

  .field-wrapper {
    width: 80%;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-evenly;

    @include breakpoint($tablet) {
      transform: scale(1.5);
    }
  }
  footer {
    margin-bottom: 20px;
    @include breakpoint($tablet) {
      margin-bottom: 80px;
    }
  }
</style>
